import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { MerchantModule } from '@merchant/merchant.module';
import { CheckableColumnModule } from '@shared/components/table/checkable-column/checkable-column.module';
import { SharedModule } from '@shared/shared.module';

import { EasylotAdminSharedModule } from '../easylot-admin-shared/easylot-admin-shared.module';
import { MerchantApprovalsComponent } from './components/merchant-approvals/merchant-approvals.component';
import { MerchantApprovalsRoutingModule } from './merchant-approvals-routing.module';
import { MerchantRejectModalComponent } from './modals/merchant-reject-modal/merchant-reject-modal.component';
import { MerchantApprovalsEffects } from './store/merchant-approvals.effects';
import { MerchantApprovalsFeature } from './store/merchant-approvals.slice';

@NgModule({
  declarations: [MerchantApprovalsComponent, MerchantRejectModalComponent],
  imports: [
    CommonModule,
    SharedModule,
    MerchantApprovalsRoutingModule,
    CheckableColumnModule,
    StoreModule.forFeature(MerchantApprovalsFeature),
    EffectsModule.forFeature([MerchantApprovalsEffects]),
    MerchantModule,
    EasylotAdminSharedModule,
  ],
})
export class MerchantApprovalsModule {}
